import { useEffect, useState } from 'react';
import qualityMetricApi from 'shared/api/quality-metric.service.api';

const EMPTY_CASES_DATA = { cases: [], totalCases: 0, totalCompliant: 0 };

export function useMetricCases({ metricId }) {
  const [casesData, setCasesData] = useState(EMPTY_CASES_DATA);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!metricId) return;

    let cancelled = false;

    const fetchCases = async () => {
      setLoading(true);
      setError(null);
      setCasesData(EMPTY_CASES_DATA);

      try {
        const { data, error: fetchError } = await qualityMetricApi.getMetricCases({
          metricId,
        });

        if (cancelled) return;

        setLoading(false);

        if (fetchError) {
          console.error('Error fetching cases:', fetchError);
          setError(fetchError);
          return;
        }

        if (data) {
          setCasesData({
            cases: data.cases || [],
            totalCases: data.total ?? 0,
            totalCompliant: data.totalCompliant ?? 0,
          });
        }
      } catch (err) {
        console.error('Unexpected error fetching cases:', err);
        if (!cancelled) {
          setLoading(false);
          setError(err);
        }
      }
    };

    fetchCases();

    return () => {
      cancelled = true;
    };
  }, [metricId]);

  return { ...casesData, loading, error };
}
